module.exports = __webpack_public_path__ + "static/media/Simbolo_Majik.d6602168.png";